<template>
  <div
    id="edit"
    :data-id="id"
    class="modal fade"
    tabindex="-1"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <div v-if="id">
            {{ name }}
          </div>
          <div v-else>
            New Category
          </div>
          <button
            type="button"
            class="btn btn-close"
            aria-label="cancel"
            @click="closeModal"
          >
            <span aria-hidden="true" />
          </button>
        </div>

        <div class="modal-body">
          <Alert
            :message="error"
            status="danger"
          />
          <div v-show="id">
            ID: {{ id }}
          </div>
          <Form
            @submit="submit"
          >
            <div class="mb-3 row g-2">
              <label
                for="category-name"
                class="col-auto col-form-label"
              >Category Name</label>
              <div class="col-auto">
                <Field
                  id="category-name"
                  v-model="name"
                  type="text"
                  name="name"
                  autocomplete="off"
                  class="form-control"
                  :rules="validateName"
                  required="required"
                />
                <ErrorMessage name="name" />
              </div>

              <div class="mb-3 row g-2">
                <label
                  for="category-parent-id"
                  class="col-auto col-form-label"
                >Parent Category</label>
                <div class="col-auto">
                  <Field
                    id="category-parent-id"
                    v-model="parent_id"
                    name="parent_id"
                    class="form-select"
                    aria-label="Select Parent Category"
                    as="select"
                    :rules="validateParentId"
                  >
                    <option />
                    <option
                      v-for="cat in categories"
                      :key="cat.id"
                      :value="cat.id"
                    >
                      {{ cat.name }}
                    </option>
                  </Field>
                  <ErrorMessage name="parent_id" />
                </div>
              </div>
            </div>
          </Form>
        </div>

        <div class="modal-footer">
          <div class="edit-button">
            <button
              type="button"
              class="btn btn-primary"
              @click="save"
            >
              Save
            </button>
            <button
              type="button"
              class="btn btn-secondary mx-2"
              aria-label="close"
              @click="cancel"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CategoryService from '@/services/admin/category.service.js';
import {Form, Field, ErrorMessage} from "vee-validate";
import { Modal, } from 'bootstrap';
import * as yup from 'yup';
import Alert from '@/components/admin/Alert.vue';
import { trackError } from '@/helpers/google-analytics-tracker';
const validateParentId = yup.number().optional().positive().integer().nullable()
const validateName = yup.string().required().min(1).nullable()

export default {
  name: "EditCategory",
  components: {
    Alert,
    Form,
    Field,
    ErrorMessage,
  },
  props: {
    id: {
      type: Number,
      default() { return null; },
    },
    initialName: {
      type: String,
      default() { return ""; },
    },
    initialParentId: {
      type: Number,
      default() { return null; },
    },
    categories: {
      type: Array,
      required: true,
      default() { return []; },
    }
  },
  emits: ['wts:category-saved'],
  data() {
    return {
      name: null,
      parent_id: null,
      moon: null,
      error: "",
      validateName,
      validateParentId,
    };
  },
  watch: {
    initialName(newVal) {
      this.name = newVal;
    },
    initialParentId(newVal) {
      this.parent_id = newVal;
    }
  },
  mounted() {
    this.moon = new Modal(document.getElementById('edit'))
  },
  methods: {
    submit() {
      this.save();
    },
    async save() {
      try {
        const { id, name, parent_id } = this;
        const resp = await CategoryService.save(
          { id, name, parent_id }
        );
        if (resp.status === 200 || resp.status === 201) {
          console.log("saved!");
          this.$emit('wts:category-saved', resp.data)
          this.moon.hide();
        }
      }
      catch(e) {
        this.error = e.message;
        console.log("Error: ", this.error)
        trackError(e);
      }
    },
    async cancel() {
      this.error = null;
      this.moon.hide();
    },
    show() {
      this.moon.show();
    },
  }
}
</script>
